<button
  mat-fab
  color="primary"
  class="fab fab-fixed-right"
  (click)="addFerry()"
  *ngIf="!itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
  [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
>
  <mat-icon>add</mat-icon>
</button>

<app-empty-list-message
  *ngIf="itinerary.reservations.ferries.length == 0"
  message="Per questo itinerario non è ancora stata inserita alcuna nave."
  actionIcon="add"
  actionLabel="Aggiungi una nave"
  (actionClick)="addFerry()"
  [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
>
</app-empty-list-message>

<mat-accordion>
  <mat-expansion-panel
    *ngFor="let ferry of itinerary.reservations.ferries; index as ferryId"
    [(expanded)]="expanded[ferryId]"
  >
    <mat-expansion-panel-header>
      <mat-panel-title fxLayoutAlign="start center">
        <mat-icon class="header-icon">directions_boat</mat-icon>
        <span class="header-title" fxFlex
          ><app-itinerary-reservations-transportation-form-title
            [transportation]="ferry"
          ></app-itinerary-reservations-transportation-form-title
        ></span>
        <div class="header-actions">
          <button
            mat-icon-button
            matTooltip="Rimuovi questa nave'"
            (click)="removeFerry($event, ferry)"
            *ngIf="
              !itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)
            "
          >
            <mat-icon aria-label="Rimuovi">delete</mat-icon>
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <app-itinerary-reservations-transportation-form
      [transportation]="ferry"
      [transportationId]="ferryId"
      [stopsFormFieldLabel]="'Scali'"
      [detailFormFieldLabel]="'porto'"
      [showCodeFormField]="false"
      [npax]="itinerary.npax"
      [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
    ></app-itinerary-reservations-transportation-form>
  </mat-expansion-panel>
</mat-accordion>
